module.exports = __webpack_public_path__ + "img/AB1.ed50a677.jpg";